import {
  FormControl,
  FormErrorMessage,
  Heading,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Box, Center, Flex } from "@chakra-ui/layout";
import loginImage from "../assets/login.png";
import PrimaryButton from "../components/PrimaryButton";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router-dom";
import { resetPassword } from "../mutations/auth.mutations";
import Logo from "../components/Logo";
import Input from "../components/inputs/Input";
import StlLoader from "../components/StlLoader";

function ResetPasswordPage() {
  const methods = useForm();
  const toast = useToast();
  const navigate = useNavigate();

  const onSubmit = async (data: FieldValues) => {
    try {
      await resetPassword({
        email: data.email,
      });
      navigate("/password/reset/done", {
        state: {
          email: data.email,
        },
      });
    } catch (err) {
      methods.setError("email", {});
      toast({
        title: "Mot de passe oublié",
        description: "Erreur interne",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <Box display={{ base: "none", lg: "block" }}>
        <StlLoader
          alternative={
            <Image
              src={loginImage}
              alt="Dan Abramov"
              h="100vh"
              w="50vw"
              display={{ base: "none", lg: "block" }}
            />
          }
        ></StlLoader>
      </Box>
      <Center w="100%">
        <Flex
          direction="column"
          alignItems="left"
          justifyContent={"center"}
          h="100vh"
          w="100%"
          px={{ base: "44px", md: "144px" }}
        >
          <Flex direction="column" alignItems="center">
            <Logo />
            <Heading
              fontWeight={600}
              fontSize="32px"
              lineHeight="48px"
              color="gray.900"
              whiteSpace="nowrap"
            >
              Mot de passe oublié
            </Heading>
            <Text
              fontWeight={400}
              fontSize="20px"
              lineHeight="30px"
              color="gray.600"
              textAlign="center"
            >
              Pas de soucis, on vous envoie un lien de réinitialisation de votre
              mot de passe
            </Text>
          </Flex>
          <FormProvider {...methods}>
            <form
              style={{ marginTop: "32px" }}
              onSubmit={methods.handleSubmit((data) => onSubmit(data))}
            >
              <FormControl isInvalid={!!methods.formState.errors.email}>
                <Input
                  id="email"
                  placeholder="Email"
                  {...methods.register("email", {
                    required: "Ce champ est obligatoire",
                  })}
                ></Input>
                <FormErrorMessage>
                  <>{methods.formState.errors?.email?.message}</>
                </FormErrorMessage>
              </FormControl>

              <PrimaryButton mt="10px" type="submit">
                Envoyer le lien de réinitialisation
              </PrimaryButton>
            </form>
          </FormProvider>
          <Center
            my="24px"
            color="brand.700"
            _hover={{ textDecoration: "underline" }}
          >
            <NavLink to="/login">Retour à la connexion</NavLink>
          </Center>
        </Flex>
      </Center>
    </Flex>
  );
}

export default ResetPasswordPage;
